(function () {
  'use strict';

  if (window.__aePopupBoot) return;
  window.__aePopupBoot = true;

  const popup = document.querySelector('[data-ae-popup-signup]');
  if (!popup) return;
  if (popup.dataset.aePopupInit === 'true') return;
  popup.dataset.aePopupInit = 'true';

  const cfg = {
    publicKey: popup.dataset.publicKey,
    listId: popup.dataset.listId,
    delaySeconds: parseInt(popup.dataset.delay, 10) || 8,
    suppressionDays: parseInt(popup.dataset.suppression, 10) || 7,
    showOn: popup.dataset.showOn || 'all',
    excludeHandlesRaw: popup.dataset.excludeHandles || '',
    excludeSuffixesRaw: popup.dataset.excludeSuffixes || '',
    currentSuffix: (popup.dataset.currentSuffix || '').toLowerCase()
  };

  const parseList = (raw) =>
    raw.split(/[\n,]+/).map((s) => s.trim().toLowerCase()).filter(Boolean);

  function currentPageHandle() {
    const m = location.pathname.match(/^\/pages\/([^/?#]+)/i);
    return m ? m[1].toLowerCase() : null;
  }

  function isExcluded() {
    const excludeHandles = parseList(cfg.excludeHandlesRaw);
    const excludeSuffixes = parseList(cfg.excludeSuffixesRaw);
    if (excludeSuffixes.length && cfg.currentSuffix && excludeSuffixes.indexOf(cfg.currentSuffix) !== -1) return true;
    if (excludeHandles.length) {
      const h = currentPageHandle();
      if (h && excludeHandles.indexOf(h) !== -1) return true;
    }
    return false;
  }

  const STORAGE_KEY = 'ae_popup_signup_v1';

  function getState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch (e) { return {}; }
  }
  function setState(s) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function shouldShow() {
    if (!cfg.publicKey || !cfg.listId) return false;
    if (isExcluded()) return false;
    const s = getState();
    if (s.subscribed) return false;
    if (s.dismissedAt) {
      const ms = cfg.suppressionDays * 24 * 60 * 60 * 1000;
      if (Date.now() - s.dismissedAt < ms) return false;
    }
    if (cfg.showOn === 'home' && location.pathname !== '/') return false;
    if (cfg.showOn === 'product' && !location.pathname.startsWith('/products/')) return false;
    return true;
  }

  function open() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ae-popup-open');
  }
const tab = document.querySelector('[data-ae-popup-tab]');
  function showTab() {
    if (!tab) return;
    const s = getState();
    if (s.tabKilled || s.subscribed) return;
    tab.hidden = false;
  }
  function hideTab() {
    if (!tab) return;
    tab.hidden = true;
  }

  function close(action) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ae-popup-open');
    if (action === 'dismiss') {
      const s = getState();
      s.dismissedAt = Date.now();
      setState(s);
      showTab();
    } else if (action === 'subscribed') {
      setState({ subscribed: true, subscribedAt: Date.now() });
      hideTab();
    }
  }

  function showStep(stepName) {
    popup.querySelectorAll('[data-ae-popup-step]').forEach((el) => {
      el.classList.toggle('is-active', el.dataset.aePopupStep === stepName);
    });
  }

  function showError(msg) {
    const err = popup.querySelector('[data-ae-popup-error]');
    if (!err) return;
    err.textContent = msg;
    err.classList.add('is-shown');
  }
  function clearError() {
    const err = popup.querySelector('[data-ae-popup-error]');
    if (!err) return;
    err.textContent = '';
    err.classList.remove('is-shown');
  }

  function isValidEmail(s) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
  }
function normalizePhone(raw) {
    if (!raw) return null;
    const digits = raw.replace(/\s|-|\(|\)|\./g, '');
    if (/^\+1[2-9]\d{9}$/.test(digits)) return digits;
    if (/^1[2-9]\d{9}$/.test(digits)) return '+' + digits;
    if (/^[2-9]\d{9}$/.test(digits)) return '+1' + digits;
    return null;
  }

  async function submitToKlaviyo({ email, phone }) {
    const profileAttrs = {
      email: email,
      properties: {
        popup_tier: phone ? 'with_phone' : 'email_only',
        popup_source: 'site_popup'
      }
    };
    if (phone) profileAttrs.phone_number = phone;

    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Site Popup',
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: {
          list: { data: { type: 'list', id: cfg.listId } }
        }
      }
    };

    const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.publicKey);
    const resp = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    });

    if (!resp.ok && resp.status !== 202) {
      let detail = '';
      try {
        const j = await resp.json();
        detail = (j.errors && j.errors[0] && j.errors[0].detail) || '';
      } catch (e) {}
      throw new Error(detail || ('Subscription failed (status ' + resp.status + ')'));
    }
    return true;
  }
popup.querySelectorAll('[data-ae-popup-next]').forEach((btn) => {
    btn.addEventListener('click', () => {
      clearError();
      showStep('form');
      const emailInput = popup.querySelector('[data-ae-popup-email]');
      if (emailInput) setTimeout(() => emailInput.focus(), 50);
    });
  });
const form = popup.querySelector('[data-ae-popup-form]');
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      clearError();

      const honey = form.querySelector('[name="ae_popup_hp"]');
      if (honey && honey.value) return;

      const emailInput = form.querySelector('[data-ae-popup-email]');
      const phoneInput = form.querySelector('[data-ae-popup-phone]');
      const consentInput = form.querySelector('[data-ae-popup-consent]');
      const submitBtn = form.querySelector('[data-ae-popup-submit]');

      const email = emailInput ? emailInput.value.trim() : '';
      const phoneRaw = phoneInput ? phoneInput.value.trim() : '';

      if (!isValidEmail(email)) {
        showError('Please enter a valid email address.');
        return;
      }

      let phone = null;
      if (phoneRaw) {
        phone = normalizePhone(phoneRaw);
        if (!phone) {
          showError('Please enter a valid US mobile number (e.g. (555) 123-4567) or leave blank for the email-only offer.');
          return;
        }
      }

      if (consentInput && !consentInput.checked) {
        showError('Please check the consent box to continue.');
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting…';
      }

      try {
        await submitToKlaviyo({ email, phone });
        showStep('success');
        setState({ subscribed: true, subscribedAt: Date.now() });
        document.dispatchEvent(new CustomEvent('ae:popup-subscribed', { detail: { email, phone } }));
      } catch (err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.label || 'Submit';
        }
        showError((err && err.message) || 'Something went wrong. Please try again.');
      }
    });
  }
popup.querySelectorAll('[data-ae-popup-close]').forEach((el) => {
    el.addEventListener('click', () => close('dismiss'));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) close('dismiss');
  });
function isAnySidebarOpen() {
    return document.querySelector('.sidebar--opened') !== null;
  }

  let tryOpenAttempts = 0;
  const TRY_OPEN_MAX = 30; /* ~30s of polling once cart-drawer opens, then give up */
  function tryOpen() {
    if (isAnySidebarOpen()) {
      if (tryOpenAttempts++ >= TRY_OPEN_MAX) return;
      setTimeout(tryOpen, 1000);
      return;
    }
    open();
  }
const cartDrawer = document.getElementById('site-cart-sidebar');
  let sidebarObserver = null;
  if (cartDrawer) {
    sidebarObserver = new MutationObserver(() => {
      if (popup.classList.contains('is-open') && isAnySidebarOpen()) {
        close('dismiss');
      }
    });
    sidebarObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }
window.addEventListener('pagehide', () => {
    if (sidebarObserver) { sidebarObserver.disconnect(); sidebarObserver = null; }
  }, { once: true });

  if (shouldShow()) {
    setTimeout(tryOpen, cfg.delaySeconds * 1000);
  } else {
const s = getState();
    if (!s.subscribed && !s.tabKilled && s.dismissedAt) {
      showTab();
    }
  }
document.querySelectorAll('[data-ae-popup-tab-open]').forEach((el) => {
    el.addEventListener('click', () => {
      hideTab();
      open();
    });
  });
document.querySelectorAll('[data-ae-popup-tab-kill]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();
      const s = getState();
      s.tabKilled = true;
      setState(s);
      hideTab();
    });
  });
window.aePopupShow = open;
  window.aePopupReset = function () {
    localStorage.removeItem(STORAGE_KEY);
    hideTab();
  };
})();
